$('document').ready(function() {

    // do things

    /// Finally, run init
    setTimeout(function() {
        Xim.init();
    }, 1);
});